// removed by extract-text-webpack-plugin
module.exports = {"viewOffersButton":"_21BNqiDlAclSMkF8RVxOfL","viewOffersButtonText":"_3wgEUkikcBaS_YKGRI8bfq","disabledButton":"_b9QMYkr-soHot2h2i2Vo","doNotShowText":"_2Yx-amd6lbflFb0jcMPKmC"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/modalButton.css
// module id = 897
// module chunks = 0